import { Component, DestroyRef, ViewChild, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ModalComponent } from '@rn-platform/frontend-shared-ui-common';
import { UserActionDialogConfig } from './user-action-dialog-config.model';
import { UserActionDialogModalService } from './user-action-dialog-modal.service';

@Component({
  selector: 'app-user-action-dialog',
  templateUrl: './user-action-dialog.component.html',
  styleUrls: ['./user-action-dialog.component.scss'],
  standalone: false
})
export class UserActionDialogComponent implements OnInit {
  private readonly userActionDialogModalService = inject(UserActionDialogModalService);
  private readonly destroyRef = inject(DestroyRef);
  userActionDialogConfig: UserActionDialogConfig;
  @ViewChild('modalRef') modalComponent: ModalComponent;

  ngOnInit(): void {
    this.userActionDialogModalService.modalState$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
      if (!data) return;
      if (data?.config) {
          this.userActionDialogConfig = data?.config;
      }
      if (data?.isOpen) {
        this.open();
      } else {
        this.close();
      }
    });
  }

  public open(): void {
    this.modalComponent?.open();
  }

  public close(): void {
    this.modalComponent?.close();
  }
}
